import _typeof from "@babel/runtime/helpers/typeof";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
var DISPLAY = {
  BLOCK: 'block',
  FLEX: 'flex',
  INLINE: 'inline',
  INLINE_BLOCK: 'inline-block',
  CONTENTS: 'contents'
};
var propTypes = {
  children: PropTypes.node.isRequired,
  onOutsideClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  useCapture: PropTypes.bool,
  display: PropTypes.oneOf(Object.values(DISPLAY))
};
var defaultProps = {
  disabled: false,
  // `useCapture` is set to true by default so that a `stopPropagation` in the
  // children will not prevent all outside click handlers from firing
  useCapture: true,
  display: DISPLAY.BLOCK
};
var OutsideClickHandler = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(OutsideClickHandler, _React$Component);
  function OutsideClickHandler() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.onMouseDown = _this.onMouseDown.bind(_assertThisInitialized(_this));
    _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_this));
    _this.setRootNodeRef = _this.setRootNodeRef.bind(_assertThisInitialized(_this));
    _this.addMouseDownEventListener = _this.addMouseDownEventListener.bind(_assertThisInitialized(_this));
    _this.removeEventListeners = _this.removeEventListeners.bind(_assertThisInitialized(_this));
    _this.abortController = new AbortController();
    return _this;
  }
  var _proto = OutsideClickHandler.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      disabled = _this$props.disabled,
      useCapture = _this$props.useCapture;
    if (!disabled) this.addMouseDownEventListener(useCapture);
  };
  _proto.componentDidUpdate = function componentDidUpdate(_ref) {
    var prevDisabled = _ref.disabled;
    var _this$props2 = this.props,
      disabled = _this$props2.disabled,
      useCapture = _this$props2.useCapture;
    if (prevDisabled !== disabled) {
      if (disabled) {
        this.removeEventListeners();
      } else {
        this.addMouseDownEventListener(useCapture);
      }
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeEventListeners();
  }

  // Use mousedown/mouseup to enforce that clicks remain outside the root's
  // descendant tree, even when dragged. This should also get triggered on
  // touch devices.
  ;
  _proto.onMouseDown = function onMouseDown(e) {
    var useCapture = this.props.useCapture;
    var isDescendantOfRoot = this.rootNode && this.rootNode.contains(e.target);
    if (!isDescendantOfRoot) {
      window.addEventListener('mouseup', this.onMouseUp, {
        capture: useCapture,
        signal: this.abortController.signal
      });
    }
  }

  // Use mousedown/mouseup to enforce that clicks remain outside the root's
  // descendant tree, even when dragged. This should also get triggered on
  // touch devices.
  ;
  _proto.onMouseUp = function onMouseUp(e) {
    var onOutsideClick = this.props.onOutsideClick;
    var isDescendantOfRoot = this.rootNode && this.rootNode.contains(e.target);
    if (!isDescendantOfRoot) {
      onOutsideClick(e);
    }
  };
  _proto.setRootNodeRef = function setRootNodeRef(ref) {
    this.rootNode = ref;
  };
  _proto.addMouseDownEventListener = function addMouseDownEventListener(useCapture) {
    // If SSR component, do not add event listeners
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) !== 'object') return;
    window.addEventListener('mousedown', this.onMouseDown, {
      capture: useCapture,
      signal: this.abortController.signal
    });
  };
  _proto.removeEventListeners = function removeEventListeners() {
    this.abortController.abort();
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      children = _this$props3.children,
      display = _this$props3.display;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.setRootNodeRef,
      style: display !== DISPLAY.BLOCK && Object.values(DISPLAY).includes(display) ? {
        display: display
      } : undefined
    }, children);
  };
  return OutsideClickHandler;
}(React.Component);
export { OutsideClickHandler as default };
OutsideClickHandler.propTypes = propTypes;
OutsideClickHandler.defaultProps = defaultProps;